module.exports = __webpack_public_path__ + "assets/img/video-btn-b1f178fd.png";